import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PRODUCTS } from "@/data/products";

export default function Products() {
  return (
    <div data-testid="page-products" className="py-16 md:py-20">
      <div className="max-w-[1480px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="overline">Full Catalogue</div>
        <h1 className="mt-4 font-serif text-5xl md:text-7xl tracking-tight">
          Premium Rice Products
        </h1>
        <p className="mt-6 text-foreground/75 text-lg max-w-2xl">
          Browse our complete range of Pakistani rice. All sourced from certified farms, processed to international standards.
        </p>

        {/* Products Grid */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border">
          {PRODUCTS.map((product) => (
            <Link
              key={product.id}
              to={`/products/${product.id}`}
              data-testid={`product-card-${product.id}`}
              className="group bg-[#0A0909] p-8 hover:bg-[#141212] transition-colors"
            >
              <div className="aspect-[4/3] w-full overflow-hidden bg-[#141212] mb-6">
                <img 
                  src={product.image} 
                  alt={product.name} 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" 
                />
              </div>
              <div className="overline">{product.sku}</div>
              <h3 className="mt-3 font-serif text-3xl tracking-tight">{product.name}</h3>
              <p className="mt-3 text-sm text-foreground/70 leading-relaxed line-clamp-2">
                {product.description}
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {product.grades.slice(0, 2).map((grade) => (
                  <span key={grade} className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground border border-border px-3 py-1">
                    {grade}
                  </span>
                ))}
              </div>
              <div className="mt-6 inline-flex items-center gap-2 text-[#3FD97A] font-mono text-[11px] uppercase tracking-[0.22em]">
                View details <ArrowRight size={14} />
              </div>
            </Link>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-20 border border-border p-10 md:p-14 bg-[#0A0909]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="overline">Custom Requirements</div>
              <h2 className="mt-4 font-serif text-4xl md:text-5xl tracking-tight">
                Can't find what you need?
              </h2>
              <p className="mt-6 text-foreground/75">
                We offer custom blends, private labeling, and specific grade requirements. Contact our export team for tailored solutions.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/rfq"
                data-testid="products-rfq-cta"
                className="inline-flex items-center justify-center gap-2 bg-[#3FD97A] hover:bg-[#4FE98A] text-[#0A0909] px-7 py-4 font-mono text-[11px] uppercase tracking-[0.22em] hover-shift font-semibold"
              >
                Request custom quote
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 border border-border hover:border-[#3FD97A] px-7 py-4 font-mono text-[11px] uppercase tracking-[0.22em] hover-shift"
              >
                Contact sales
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
